<div class="card">
  <div class="card-header card-header-squirrel">
      <h4>API Token entfernen</h4>
      <!-- <h6>{{this.translate.data['USER'] | translate}}: {{userName}}</h6> -->
  </div>

  <div class="card-body">
      <form [formGroup]="userDeleteForm">
          <mat-form-field class="example-full-width" style="width: 0; height: 0;">
              <input matInput hidden formControlName="id" readonly>
          </mat-form-field>

          <div class="row container">
            <!-- <div class="col-md-12">
              <output formControlName="apiToken">{{data}}</output>
            </div> -->
            <div class="output">API Token für {{userDto.user_Name}} gültig bis {{userDto.valid_Until}} entfernen?</div>
          </div>

          <!-- <mat-form-field class="example-full-width">
              <input matInput formControlName="userName" readonly>
          </mat-form-field> -->

          <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-left: 0px" matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}"
              (click)="cancel()" >Abbruch</button>
          <button  mat-raised-button class="btn btn-squirrel pull-right" (click)="deleteUser(userDto.id)" color="primary">Entfernen</button>
      </form>
  </div>
</div>
